/**
 * Module dependencies.
 */

import { TourAssets } from 'src/types/tour';

/**
 * Export `toursAssets`.
 */

export const toursAssets: TourAssets = {
  alcoutim: {
    sections: {
      authorsNotes: {
        image: `/images/episodes/alcoutim/map.jpg`
      },
      bestOf: {
        image1: {
          image: `/images/episodes/alcoutim/best-of-image-1-1.jpg`
        },
        image2: {
          image: `/images/episodes/alcoutim/best-of-image-1-2.jpg`
        },
        image3: {
          image: `/images/episodes/alcoutim/best-of-image-2-1.jpg`
        },
        image4: {
          image: `/images/episodes/alcoutim/best-of-image-2-2.jpg`
        },
        image5: `/images/episodes/alcoutim/best-of-image-2-3.jpg`
      },
      book: {
        image: `/images/episodes/alcoutim/map-travel.jpg`
      },
      guest: {
        assets: {
          authorCoverImage: `/images/episodes/alcoutim/cover.jpg`,
          authorImage: `/images/episodes/alcoutim/author.jpg`,
          bioImage: `/images/episodes/alcoutim/author.jpg`,
          coverVideo: `/videos/episodes/alcoutim/cover.mp4`,
          guestCoverImage: `/images/episodes/alcoutim/cover.jpg`,
          guestImage: `/images/episodes/alcoutim/cover.jpg`
        }
      },
      tips: {
        images: {
          first: `/images/episodes/alcoutim/nature.jpg`,
          second: `/images/episodes/alcoutim/culture.jpg`,
          third: `/images/episodes/alcoutim/patrimony.jpg`
        }
      },
      video: {
        cover: `/images/episodes/alcoutim/video-cover.jpg`,
        url: `https://www.youtube.com/watch?v=OdHT8o1xuok`
      }
    }
  },
  beja: {
    sections: {
      authorsNotes: {
        image: `/images/episodes/beja/map.jpg`
      },
      bestOf: {
        image1: {
          image: `/images/episodes/beja/best-of-image-1-1.jpg`
        },
        image2: {
          image: `/images/episodes/beja/best-of-image-1-2.jpg`
        },
        image3: {
          image: `/images/episodes/beja/best-of-image-2-1.jpg`
        },
        image4: {
          image: `/images/episodes/beja/best-of-image-2-2.jpg`
        },
        image5: `/images/episodes/beja/best-of-image-2-3.jpg`
      },
      book: {
        image: `/images/episodes/beja/map-travel.jpg`
      },
      guest: {
        assets: {
          authorCoverImage: `/images/episodes/beja/cover.jpg`,
          authorImage: `/images/episodes/beja/author.jpg`,
          bioImage: `/images/episodes/beja/author.jpg`,
          coverVideo: `/videos/episodes/beja/cover.mp4`,
          guestCoverImage: `/images/episodes/beja/cover.jpg`,
          guestImage: `/images/episodes/beja/cover.jpg`
        }
      },
      tips: {
        images: {
          first: `/images/episodes/beja/nature.jpg`,
          second: `/images/episodes/beja/culture.jpg`,
          third: `/images/episodes/beja/patrimony.jpg`
        }
      },
      video: {
        cover: `/images/episodes/beja/video-cover.jpg`,
        url: `https://www.youtube.com/watch?v=XR0RXiVOFU0`
      }
    }
  },
  braganca: {
    sections: {
      authorsNotes: {
        image: `/images/episodes/braganca/map.jpg`
      },
      bestOf: {
        image1: {
          image: `/images/episodes/braganca/best-of-image-1-1.jpg`
        },
        image2: {
          image: `/images/episodes/braganca/best-of-image-1-2.jpg`
        },
        image3: {
          image: `/images/episodes/braganca/best-of-image-2-1.jpg`
        },
        image4: {
          image: `/images/episodes/braganca/best-of-image-2-2.jpg`
        },
        image5: `/images/episodes/braganca/best-of-image-2-3.jpg`
      },
      book: {
        image: `/images/episodes/braganca/map-travel.jpg`
      },
      guest: {
        assets: {
          authorCoverImage: `/images/episodes/braganca/cover.jpg`,
          authorImage: `/images/episodes/braganca/author.jpg`,
          bioImage: `/images/episodes/braganca/author.jpg`,
          coverVideo: `/videos/episodes/braganca/cover.mp4`,
          guestCoverImage: `/images/episodes/braganca/cover.jpg`,
          guestImage: `/images/episodes/braganca/cover.jpg`
        }
      },
      tips: {
        images: {
          first: `/images/episodes/braganca/nature.jpg`,
          second: `/images/episodes/braganca/culture.jpg`,
          third: `/images/episodes/braganca/patrimony.jpg`
        }
      },
      video: {
        cover: `/images/episodes/braganca/video-cover.jpg`,
        url: `https://www.youtube.com/watch?v=QswoNmHPgLg`
      }
    }
  },
  coimbra: {
    sections: {
      authorsNotes: {
        image: `/images/episodes/coimbra/map.jpg`
      },
      bestOf: {
        image1: {
          image: `/images/episodes/coimbra/best-of-image-1-1.jpg`
        },
        image2: {
          image: `/images/episodes/coimbra/best-of-image-1-2.jpg`
        },
        image3: {
          image: `/images/episodes/coimbra/best-of-image-2-1.jpg`
        },
        image4: {
          image: `/images/episodes/coimbra/best-of-image-2-2.jpg`
        },
        image5: `/images/episodes/coimbra/best-of-image-2-3.jpg`
      },
      book: {
        image: `/images/episodes/coimbra/map-travel.jpg`
      },
      guest: {
        assets: {
          authorCoverImage: `/images/episodes/coimbra/cover.jpg`,
          authorImage: `/images/episodes/coimbra/guest.jpg`,
          bioImage: `/images/episodes/coimbra/guest.jpg`,
          coverVideo: `/videos/episodes/coimbra/cover.mp4`,
          guestCoverImage: `/images/episodes/coimbra/guest-cover.jpg`,
          guestImage: `/images/episodes/coimbra/author.jpg`
        }
      },
      tips: {
        images: {
          first: `/images/episodes/coimbra/nature.jpg`,
          second: `/images/episodes/coimbra/culture.jpg`,
          third: `/images/episodes/coimbra/patrimony.jpg`
        }
      },
      video: {
        cover: `/images/episodes/coimbra/video-cover.jpg`,
        url: `https://www.youtube.com/watch?v=dq6rlpYVcCA`
      }
    }
  },
  'evora-montemor-o-novo': {
    sections: {
      authorsNotes: {
        image: `/images/episodes/evora-montemor-o-novo/map.jpg`
      },
      bestOf: {
        image1: {
          image: `/images/episodes/evora-montemor-o-novo/best-of-image-1-1.jpg`
        },
        image2: {
          image: `/images/episodes/evora-montemor-o-novo/best-of-image-1-2.jpg`
        },
        image3: {
          image: `/images/episodes/evora-montemor-o-novo/best-of-image-2-1.jpg`
        },
        image4: {
          image: `/images/episodes/evora-montemor-o-novo/best-of-image-2-2.jpg`
        },
        image5: `/images/episodes/evora-montemor-o-novo/best-of-image-2-3.jpg`
      },
      book: {
        image: `/images/episodes/evora-montemor-o-novo/map-travel.jpg`
      },
      guest: {
        assets: {
          authorCoverImage: `/images/episodes/evora-montemor-o-novo/cover.jpg`,
          authorImage: `/images/episodes/evora-montemor-o-novo/guest.jpg`,
          bioImage: `/images/episodes/evora-montemor-o-novo/guest.jpg`,
          coverVideo: `/videos/episodes/evora-montemor-o-novo/cover.mp4`,
          guestCoverImage: `/images/episodes/evora-montemor-o-novo/cover.jpg`,
          guestImage: `/images/episodes/evora-montemor-o-novo/author.jpg`
        }
      },
      tips: {
        images: {
          first: `/images/episodes/evora-montemor-o-novo/nature.jpg`,
          second: `/images/episodes/evora-montemor-o-novo/culture.jpg`,
          third: `/images/episodes/evora-montemor-o-novo/patrimony.jpg`
        }
      },
      video: {
        cover: `/images/episodes/evora-montemor-o-novo/video-cover.jpg`,
        url: `https://www.youtube.com/watch?v=a03XNIBjXII`
      }
    }
  },
  'guarda-pinhel-cidadelhe': {
    sections: {
      authorsNotes: {
        image: `/images/episodes/guarda/map.jpg`
      },
      bestOf: {
        image1: {
          image: `/images/episodes/guarda/best-of-image-1-1.jpg`
        },
        image2: {
          image: `/images/episodes/guarda/best-of-image-1-2.jpg`
        },
        image3: {
          image: `/images/episodes/guarda/best-of-image-2-1.jpg`
        },
        image4: {
          image: `/images/episodes/guarda/best-of-image-2-2.jpg`
        },
        image5: `/images/episodes/guarda/best-of-image-2-3.jpg`
      },
      book: {
        image: `/images/episodes/guarda/map-travel.jpg`
      },
      guest: {
        assets: {
          authorCoverImage: `/images/episodes/guarda/cover.jpg`,
          authorImage: `/images/episodes/guarda/author.jpg`,
          bioImage: `/images/episodes/guarda/author.jpg`,
          coverVideo: `/videos/episodes/guarda/cover.mp4`,
          guestCoverImage: `/images/episodes/guarda/cover.jpg`,
          guestImage: `/images/episodes/guarda/cover.jpg`
        }
      },
      tips: {
        images: {
          first: `/images/episodes/guarda/nature.jpg`,
          second: `/images/episodes/guarda/culture.jpg`,
          third: `/images/episodes/guarda/patrimony.jpg`
        }
      },
      video: {
        cover: `/images/episodes/guarda/video-cover.png`,
        url: `https://www.youtube.com/watch?v=s6HPCxBp3Lw`
      }
    }
  },
  guimaraes: {
    sections: {
      authorsNotes: {
        image: `/images/episodes/guimaraes/map.jpg`
      },
      bestOf: {
        image1: {
          image: `/images/episodes/guimaraes/best-of-image-1-1.jpg`
        },
        image2: {
          image: `/images/episodes/guimaraes/best-of-image-1-2.jpg`
        },
        image3: {
          image: `/images/episodes/guimaraes/best-of-image-2-1.jpg`
        },
        image4: {
          image: `/images/episodes/guimaraes/best-of-image-2-2.jpg`
        },
        image5: `/images/episodes/guimaraes/best-of-image-2-3.jpg`
      },
      book: {
        image: `/images/episodes/guimaraes/map-travel.jpg`
      },
      guest: {
        assets: {
          authorCoverImage: `/images/episodes/guimaraes/cover.jpg`,
          authorImage: `/images/episodes/guimaraes/guest.jpg`,
          bioImage: `/images/episodes/guimaraes/guest.jpg`,
          coverVideo: `/videos/episodes/guimaraes/cover.mp4`,
          guestCoverImage: `/images/episodes/guimaraes/cover.jpg`,
          guestImage: `/images/episodes/guimaraes/author.jpg`
        }
      },
      tips: {
        images: {
          first: `/images/episodes/guimaraes/nature.jpg`,
          second: `/images/episodes/guimaraes/culture.jpg`,
          third: `/images/episodes/guimaraes/patrimony.jpg`
        }
      },
      video: {
        cover: `/images/episodes/guimaraes/video-cover.png`,
        url: `https://youtu.be/7xB0cafVupU`
      }
    }
  },
  lagos: {
    sections: {
      authorsNotes: {
        image: `/images/episodes/lagos/map.jpg`
      },
      bestOf: {
        image1: {
          image: `/images/episodes/lagos/best-of-image-1-1.jpg`
        },
        image2: {
          image: `/images/episodes/lagos/best-of-image-1-2.jpg`
        },
        image3: {
          image: `/images/episodes/lagos/best-of-image-2-1.jpg`
        },
        image4: {
          image: `/images/episodes/lagos/best-of-image-2-2.jpg`
        },
        image5: `/images/episodes/lagos/best-of-image-2-3.jpg`
      },
      book: {
        image: `/images/episodes/lagos/map-travel.png`
      },
      guest: {
        assets: {
          authorCoverImage: `/images/episodes/lagos/cover.jpg`,
          authorImage: `/images/episodes/lagos/guest.jpg`,
          bioImage: `/images/episodes/lagos/guest.jpg`,
          coverVideo: `/videos/episodes/lagos/cover.mp4`,
          guestCoverImage: `/images/episodes/lagos/guest-cover.jpg`,
          guestImage: `/images/episodes/lagos/author.jpg`
        }
      },
      tips: {
        images: {
          first: `/images/episodes/lagos/nature.jpg`,
          second: `/images/episodes/lagos/culture.jpg`,
          third: `/images/episodes/lagos/patrimony.jpg`
        }
      },
      video: {
        cover: `/images/episodes/lagos/video-cover.png`,
        url: `https://www.youtube.com/watch?v=x7443fCVYaQ`
      }
    }
  },
  'lisboa-sintra-cascais': {
    sections: {
      authorsNotes: {
        image: `/images/episodes/lisboa-sintra-cascais/map.jpg`
      },
      bestOf: {
        image1: {
          image: `/images/episodes/lisboa-sintra-cascais/best-of-image-1-1.jpg`
        },
        image2: {
          image: `/images/episodes/lisboa-sintra-cascais/best-of-image-1-2.jpg`
        },
        image3: {
          image: `/images/episodes/lisboa-sintra-cascais/best-of-image-2-1.jpg`
        },
        image4: {
          image: `/images/episodes/lisboa-sintra-cascais/best-of-image-2-2.jpg`
        },
        image5: `/images/episodes/lisboa-sintra-cascais/best-of-image-2-3.jpg`
      },
      book: {
        image: `/images/episodes/lisboa-sintra-cascais/map-travel.png`
      },
      guest: {
        assets: {
          authorCoverImage: `/images/episodes/lisboa-sintra-cascais/cover.jpg`,
          authorImage: `/images/episodes/lisboa-sintra-cascais/guest.jpg`,
          bioImage: `/images/episodes/lisboa-sintra-cascais/guest.jpg`,
          coverVideo: `/videos/episodes/lisboa-sintra-cascais/cover.mp4`,
          guestCoverImage: `/images/episodes/lisboa-sintra-cascais/guest-cover.jpg`,
          guestImage: `/images/episodes/lisboa-sintra-cascais/author.jpg`
        }
      },
      tips: {
        images: {
          first: `/images/episodes/lisboa-sintra-cascais/nature.jpg`,
          second: `/images/episodes/lisboa-sintra-cascais/culture.jpg`,
          third: `/images/episodes/lisboa-sintra-cascais/patrimony.jpg`
        }
      },
      video: {
        cover: `/images/episodes/lisboa-sintra-cascais/video-cover.jpg`,
        url: `https://www.youtube.com/watch?v=gLyCDeK1cbw&ab_channel=VisitPortugal`
      }
    }
  },
  mafra: {
    sections: {
      authorsNotes: {
        image: `/images/episodes/mafra/map.jpg`
      },
      bestOf: {
        image1: {
          image: `/images/episodes/mafra/best-of-image-1-1.jpg`
        },
        image2: {
          image: `/images/episodes/mafra/best-of-image-1-2.jpg`
        },
        image3: {
          image: `/images/episodes/mafra/best-of-image-2-1.jpg`
        },
        image4: {
          image: `/images/episodes/mafra/best-of-image-2-2.jpg`
        },
        image5: `/images/episodes/mafra/best-of-image-2-3.jpg`
      },
      book: {
        image: `/images/episodes/mafra/map-travel.jpg`
      },
      guest: {
        assets: {
          authorCoverImage: `/images/episodes/mafra/cover.jpg`,
          authorImage: `/images/episodes/mafra/guest.jpg`,
          bioImage: `/images/episodes/mafra/guest.jpg`,
          coverVideo: `/videos/episodes/mafra/cover.mp4`,
          guestCoverImage: `/images/episodes/mafra/guest-cover.jpg`,
          guestImage: `/images/episodes/mafra/author.jpg`
        }
      },
      tips: {
        images: {
          first: `/images/episodes/mafra/nature.jpg`,
          second: `/images/episodes/mafra/culture.jpg`,
          third: `/images/episodes/mafra/patrimony.jpg`
        }
      },
      video: {
        cover: `/images/episodes/mafra/video-cover.jpg`,
        url: `https://www.youtube.com/watch?v=wHiDVppaCUc`
      }
    }
  },
  setubal: {
    sections: {
      authorsNotes: {
        image: `/images/episodes/setubal/map.jpg`
      },
      bestOf: {
        image1: {
          image: `/images/episodes/setubal/best-of-image-1-1.jpg`
        },
        image2: {
          image: `/images/episodes/setubal/best-of-image-1-2.jpg`
        },
        image3: {
          image: `/images/episodes/setubal/best-of-image-2-1.jpg`
        },
        image4: {
          image: `/images/episodes/setubal/best-of-image-2-2.jpg`
        },
        image5: `/images/episodes/setubal/best-of-image-2-3.jpg`
      },
      book: {
        image: `/images/episodes/setubal/map-travel.jpg`
      },
      guest: {
        assets: {
          authorCoverImage: `/images/episodes/setubal/cover.jpg`,
          authorImage: `/images/episodes/setubal/author.jpg`,
          bioImage: `/images/episodes/setubal/author.jpg`,
          coverVideo: `/videos/episodes/setubal/cover.mp4`,
          guestCoverImage: `/images/episodes/setubal/cover.jpg`,
          guestImage: `/images/episodes/setubal/cover.jpg`
        }
      },
      tips: {
        images: {
          first: `/images/episodes/setubal/nature.jpg`,
          second: `/images/episodes/setubal/culture.jpg`,
          third: `/images/episodes/setubal/patrimony.jpg`
        }
      },
      video: {
        cover: `/images/episodes/setubal/video-cover.png`,
        url: `https://www.youtube.com/watch?v=4WKsb8UbJh0`
      }
    }
  },
  'tomar-constancia': {
    sections: {
      authorsNotes: {
        image: `/images/episodes/tomar/map.jpg`
      },
      bestOf: {
        image1: {
          image: `/images/episodes/tomar/best-of-image-1-1.jpg`
        },
        image2: {
          image: `/images/episodes/tomar/best-of-image-1-2.jpg`
        },
        image3: {
          image: `/images/episodes/tomar/best-of-image-2-1.jpg`
        },
        image4: {
          image: `/images/episodes/tomar/best-of-image-2-2.jpg`
        },
        image5: `/images/episodes/tomar/best-of-image-2-3.jpg`
      },
      book: {
        image: `/images/episodes/tomar/map-travel.jpg`
      },
      guest: {
        assets: {
          authorCoverImage: `/images/episodes/tomar/cover.jpg`,
          authorImage: `/images/episodes/tomar/author.jpg`,
          bioImage: `/images/episodes/tomar/author.jpg`,
          coverVideo: `/videos/episodes/tomar/cover.mp4`,
          guestCoverImage: `/images/episodes/tomar/cover.jpg`,
          guestImage: `/images/episodes/tomar/cover.jpg`
        }
      },
      tips: {
        images: {
          first: `/images/episodes/tomar/nature.jpg`,
          second: `/images/episodes/tomar/culture.jpg`,
          third: `/images/episodes/tomar/patrimony.jpg`
        }
      },
      video: {
        cover: `/images/episodes/tomar/video-cover.png`,
        url: `https://www.youtube.com/watch?v=-y89Bo-L4OE`
      }
    }
  },
  'vila-real': {
    sections: {
      authorsNotes: {
        image: `/images/episodes/vila-real/map.jpg`
      },
      bestOf: {
        image1: {
          image: `/images/episodes/vila-real/best-of-image-1-1.jpg`
        },
        image2: {
          image: `/images/episodes/vila-real/best-of-image-1-2.jpg`
        },
        image3: {
          image: `/images/episodes/vila-real/best-of-image-2-1.jpg`
        },
        image4: {
          image: `/images/episodes/vila-real/best-of-image-2-2.jpg`
        },
        image5: `/images/episodes/vila-real/best-of-image-2-3.jpg`
      },
      book: {
        image: `/images/episodes/vila-real/map-travel.jpg`
      },
      guest: {
        assets: {
          authorCoverImage: `/images/episodes/vila-real/cover.jpg`,
          authorImage: `/images/episodes/vila-real/guest.jpg`,
          bioImage: `/images/episodes/vila-real/guest.jpg`,
          coverVideo: `/videos/episodes/vila-real/cover.mp4`,
          guestCoverImage: `/images/episodes/vila-real/cover.jpg`,
          guestImage: `/images/episodes/vila-real/author.jpg`
        }
      },
      tips: {
        images: {
          first: `/images/episodes/vila-real/nature.jpg`,
          second: `/images/episodes/vila-real/culture.jpg`,
          third: `/images/episodes/vila-real/patrimony.jpg`
        }
      },
      video: {
        cover: `/images/episodes/vila-real/video-cover.png`,
        url: `https://youtu.be/0TBMl6LSE7M`
      }
    }
  }
};
